import React, { useState, useEffect, useRef } from 'react';

//import DataModel from './common/DataModel';

//Components
import Dropdown from './components/Dropdown';
import Radio from './components/Radio';


const App = () => {
    const [ DataModel, setDataModel] = useState(null);

    const requiredFieldRef = useRef(null);
    const savingsResultRef = useRef(null);
    
    const defaultEnergySourceValue = "direct_el";
    const [ energySource, setEnergySource ] = useState(null);
    const [ heatDistribution, setHeatDistribution ] = useState(null);
    
    const [ elConsumption, setElConsumption ] = useState(null); //This should be NULL by default
    const [ electricityPrice, setElectricityPrice ] = useState(null);
    
    const [ oilConsumption, setOilConsumption ] = useState(null); //This should be NULL by default
    const [ oilPrice, setOilPrice ] = useState(null);
    
    const [ pelletConsumption, setPelletConsumption ] = useState(null); //This should be NULL by default
    const [ pelletPrice, setPelletPrice ] = useState(null);
    
    const [ centralConsumption, setCentralConsumption ] = useState(null); //This should be NULL by default
    const [ centralPrice, setCentralPrice ] = useState(null);

    const [ showHeatPumpInfo, setShowHeatPumpInfo ] = useState(false);
    const [ savings, setSavings ] = useState(false);
    const [ showSavings, setShowSavings ] = useState(false);
    const [ oldCost, setOldCost ] = useState(false);
    const [ newCost, setNewCost ] = useState(false);
    
    const getData=()=>{
        fetch(window.calculatorExternalDataUrl
        ,{
            headers: {
                'Content-Type': 'application/json',
            }
        }
        )
          .then(function(response){
            return response.json();
          })
          .then(function(jsonData) {

            setDataModel(jsonData);

            setEnergySource("direct_el");
            setHeatDistribution("radiator");

            setElConsumption(jsonData.data.price_electricity);
            setElectricityPrice(jsonData.data.price_electricity);
            setOilConsumption(jsonData.data.oil_normal_consumption);
            setOilPrice(jsonData.data.price_oil);
            setPelletConsumption(jsonData.data.pellet_normal_consumption);
            setPelletPrice(jsonData.data.price_pellets);
            setCentralConsumption(jsonData.data.central_heating_normal_consumption);
            setCentralPrice(jsonData.data.price_central);

          });
      }
      useEffect(()=>{
        if (DataModel === null) {
            getData();
        }
      },[DataModel])

    useEffect(() => {
        if( energySource === 'heat_pump' ) {
            setShowHeatPumpInfo(true);
        } else {
            setShowHeatPumpInfo(false);
        }

    }, [energySource]);
    
    if (DataModel === null) {
        return;
    }
    
    const currencyFormatter = new Intl.NumberFormat(
        DataModel.lang.iso_lang_code, {
            style: 'currency',
            currency: DataModel.lang.currency,
            maximumFractionDigits: 0
        }
    );


    function hideSavings() {
        setSavings(false);
        setShowSavings(false);
    }

    function showCtaButtons(buttons) {
        if(buttons) {
            return(
                <>
                    {buttons.map( (button) => {
                        if(button.button_title && button.button_url) {
                            return <a key={button.button_title} className={`link-cta color-${button.button_color ? button.button_color : "blue"}`} href={button.button_url}>{button.button_title}</a>
                        } else {
                            return false;
                        }
                    })}
                </>
            )
        }
        return false;
    }

    function calculate_el(current_consumption, electricity_price, factor) {
        const oldCost = Math.round((current_consumption) * electricity_price);
        const newConsumption = Math.round((current_consumption) / factor);
        const newCost = Math.round((newConsumption * electricity_price));

        console.log(oldCost, newCost, current_consumption, electricity_price, factor);

        return {
            old_cost: oldCost,
            new_cost: newCost
        }
    }

    function calculate_oil(current_consumption, current_price, electricity_price, efficiency, factor) {
        const squareMeterCompensation = 10000;
        const oldConsumptionAfterCompensation = current_consumption * squareMeterCompensation;
        

        const oldCost = Math.round(current_consumption * current_price);
        const newConsumption = Math.round(oldConsumptionAfterCompensation / factor);
        const newCost = Math.round((newConsumption * electricity_price) * efficiency);
        
        console.log(oldCost, newCost, current_consumption, current_price, electricity_price, efficiency, factor);

        return {
            old_cost: oldCost,
            new_cost: newCost
        }
    }

    

    function calculate_pellets(current_consumption, current_price, electricity_price, efficiency, factor) {
        const pelletsCompensation = 4600;
        const oldConsumptionAfterCompensation = current_consumption * pelletsCompensation;
     
        const oldCost = Math.round(current_consumption * current_price);

        const newConsumption = Math.round(oldConsumptionAfterCompensation / factor);
        const newCost = Math.round((newConsumption * electricity_price) * efficiency);

        console.log(oldCost, newCost, current_consumption, current_price, electricity_price, efficiency, factor);

        return {
            old_cost: oldCost,
            new_cost: newCost
        }
    }


    function calculate_central(current_consumption, current_price, electricity_price, efficiency, factor) {
        
        const oldCost = Math.round(current_consumption * current_price);

        const newConsumption = Math.round(current_consumption / factor);
        const newCost = Math.round((newConsumption * electricity_price) * efficiency);

        console.log(oldCost, newCost, current_consumption, current_price, electricity_price, efficiency, factor);

        return {
            old_cost: oldCost,
            new_cost: newCost
        }
    }
    
    function calculateSavings(){
        const requiredField = requiredFieldRef.current; //We have only one requred field per energy source, so we can have only on ref
        const savingsResultElem = savingsResultRef.current

        if(!requiredField.value) {
            requiredField.className = "validation-error";
            requiredField.focus();
            return false;
        } else {
            requiredField.className = "";
        }
        
        let oldCost = 0;
        let newCost = 0;
        let efficiency = DataModel.data.heatpump_efficiency;

        let factor = (heatDistribution === "radiator") ? DataModel.data.radiator_factor : DataModel.data.floor_heating_factor;

        let electricityPriceNormalized = electricityPrice / 100; // convert from öre to kr or cent to euro

        if(energySource === "direct_el") {

            const calculated = calculate_el(elConsumption, electricityPriceNormalized, factor);
            oldCost = calculated.old_cost;
            newCost = calculated.new_cost;
        }
        if(energySource === "waterborne_el") {
            const calculated = calculate_el(elConsumption, electricityPriceNormalized, factor);
            oldCost = calculated.old_cost;
            newCost = calculated.new_cost;
        }
        if(energySource === "oil") {
            const calculated = calculate_oil(oilConsumption, oilPrice, electricityPriceNormalized, efficiency, factor);
            oldCost = calculated.old_cost;
            newCost = calculated.new_cost;
        }
        if(energySource === "pellets") {
            const calculated = calculate_pellets(pelletConsumption, pelletPrice, electricityPriceNormalized, efficiency, factor);
            oldCost = calculated.old_cost;
            newCost = calculated.new_cost;
        }
        if(energySource === "central") {
            const calculated = calculate_central(centralConsumption, centralPrice / 100, electricityPriceNormalized, efficiency, factor);
            oldCost = calculated.old_cost;
            newCost = calculated.new_cost;
        }

        let saving = oldCost - newCost;

        if(saving > 0) {
            setSavings(currencyFormatter.format(saving));
        } else {
            setSavings(false);
        }
        if(oldCost > newCost) {
            setOldCost(currencyFormatter.format(oldCost));
            setNewCost(currencyFormatter.format(newCost));
        } else {
            setOldCost(false)
            setNewCost(false)
        }

        setShowSavings(true);


        if (showSavings) {
            savingsResultElem.scrollIntoView({behavior: "smooth"});
        }
    }



    return (
        <div className="calculator-wrapper">
            <h3 className='text-center'>{DataModel.lang.subtitle}</h3>
            <h2 className='text-center'>{DataModel.lang.title}</h2>
            <div className="flex-row">
                <div className="flex-row flex-dir-col">
                    <div className='flex-row'>
                        <div className='flex-col'>
                            <h3>{DataModel.lang.energy_source_title}</h3>
                        </div>
                        <div className='flex-col'>
                            <Dropdown DataModel={DataModel} dropdownSetEnergySource={setEnergySource} dropdownHideSavings={hideSavings} />
                        </div>
                    </div>

                    <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                        <div className='flex-col heat-distribution'>
                            <h3>{energySource === defaultEnergySourceValue ? DataModel.lang.desired_heat_distribution_title : DataModel.lang.current_heat_distribution_title}</h3>
                        </div>
                        <div className='flex-col'>
                            <Radio DataModel={DataModel} radioSetHeatDistribution={setHeatDistribution} radioHideSavings={hideSavings} />
                        </div>
                    </div>

                    {['direct_el', 'waterborne_el'].includes(energySource) &&
                        <div className={`flex-row margin-bottom-30 ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                            <div className='flex-col'>
                                <h3>{DataModel.lang.el_consumption_title}</h3>
                            </div>
                            <div className='flex-col'>
                                <input 
                                    ref={requiredFieldRef}
                                    type="number" 
                                    inputMode="numeric"
                                    placeholder={DataModel.lang.el_consumption_placeholder}
                                    onChange={(e) => {
                                        const elConsumption = parseFloat(e.target.value.replace(/,/, '.'));
                                        setElConsumption(elConsumption);
                                        hideSavings();
                                    }}
                                />
                                <p className='calc-help-text'>
                                    
                                    {DataModel.lang.el_consumption_help_text} {DataModel.data.household_electricity} kWh
                                </p>
                            </div>
                        </div>
                    }

                    {energySource === 'oil' && (
                        <>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.oil_consumption_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        ref={requiredFieldRef}
                                        type="text"
                                        inputMode="decimal"
                                        placeholder={DataModel.lang.oil_consumption_placeholder}
                                        onChange={(e) => {
                                            const oilConsumption = parseFloat(e.target.value.replace(/,/, '.'));

                                            setOilConsumption(oilConsumption);
                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.oil_consumption_help_text}
                                    </p>
                                </div>
                            </div>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.oil_cost_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        type="number"
                                        inputMode="numeric"
                                        placeholder={currencyFormatter.format(DataModel.data.price_oil)}
                                        onChange={(e) => {

                                            if (e.target.value === "") {
                                                setOilPrice(DataModel.data.price_oil);
                                            } else {
                                                setOilPrice(parseFloat(e.target.value));
                                            }

                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.price_help_text}
                                    </p>
                                </div>
                            </div>
                        </>
                    )}

                    {energySource === 'pellets' && (
                        <>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.pellets_consumption_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        ref={requiredFieldRef}
                                        type="text"
                                        inputMode="decimal"
                                        placeholder={DataModel.lang.pellets_consumption_placeholder}
                                        onChange={(e) => {
                                            const pelletsConsumption = parseFloat(e.target.value.replace(/,/, '.'));

                                            setPelletConsumption(pelletsConsumption);
                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.pellets_consumption_help_text}
                                    </p>
                                </div>
                            </div>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.pellets_cost_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        type="number"
                                        inputMode="numeric"
                                        placeholder={currencyFormatter.format(DataModel.data.price_pellets)}
                                        onChange={(e) => {
                                            if (e.target.value === "") {
                                                setPelletPrice(DataModel.data.price_pellets);
                                            } else {
                                                setPelletPrice(parseFloat(e.target.value));
                                            }
                                            
                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.price_help_text}
                                    </p>
                                </div>
                            </div>
                        </>
                    )}
                    {energySource === 'central' && (
                        <>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.central_consumption_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        ref={requiredFieldRef}
                                        type="number"
                                        inputMode="numeric"
                                        placeholder={DataModel.lang.central_consumption_placeholder}
                                        onChange={(e) => {
                                            setCentralConsumption(parseFloat(e.target.value));
                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.central_consumption_help_text}
                                    </p>
                                </div>
                            </div>
                            <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                                <div className='flex-col'>
                                    <h3>{DataModel.lang.central_cost_title}</h3>
                                </div>
                                <div className='flex-col'>
                                    <input 
                                        type="number"
                                        inputMode="numeric"
                                        placeholder={DataModel.data.price_central + " " + DataModel.lang.electricy_price_placeholder}
                                        onChange={(e) => {
                                            if (e.target.value === "") {
                                                setCentralPrice(DataModel.data.price_central);
                                            } else {
                                                setCentralPrice(parseFloat(e.target.value));
                                            }

                                            hideSavings();
                                        }}
                                    />
                                    <p className='calc-help-text'>
                                        {DataModel.lang.price_help_text}
                                    </p>
                                </div>
                            </div>
                        </>
                    )}

                    <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                        <div className='flex-col'>
                            <h3>{DataModel.lang.electricy_price_title}</h3>
                        </div>
                        <div className='flex-col'>
                            <input 
                                type="number" 
                                inputMode="numeric"
                                placeholder={DataModel.data.price_electricity + " " +  DataModel.lang.electricy_price_placeholder}
                                onChange={(e) => {
                                    if (e.target.value === "") {
                                        setElectricityPrice(DataModel.data.price_electricity);
                                    } else {
                                        setElectricityPrice(parseFloat(e.target.value));
                                    }

                                    hideSavings();
                                }}
                            />
                            <p className='calc-help-text'>
                                {DataModel.lang.price_help_text}
                            </p>
                        </div>
                    </div>

                    <div className={`flex-row ${showHeatPumpInfo ? 'element-disabled' : ''}`}>
                        <div className='flex-col'></div>
                        <div className='flex-col'>
                            <button 
                                onClick={() => {
                                    calculateSavings()
                                }}
                                className="blue-button"
                            >
                                {DataModel.lang.calculate_button_text}
                            </button>
                        </div>
                    </div>
                </div>
                <div ref={savingsResultRef} className='flex-row flex-size-33 flex-dir-col'>
                    {(showSavings && !showHeatPumpInfo) && (
                        <div className='savings-element-wrapper text-center'>
                            <div className="savings-element">
                                <h4>{DataModel.lang.savings_title}</h4>
                                <h4>{DataModel.lang.savings_subtitle}</h4>
                                {savings && <h3 className='savings'>{savings}</h3>}
                                <p>{DataModel.lang.savings_text}</p>
                                {showCtaButtons(DataModel.lang.cta_buttons)}
                                {oldCost && <div className='savings-old-new'>{DataModel.lang.savings_your_cost_now} {oldCost}</div>}
                                {newCost && <div className='savings-old-new'>{DataModel.lang.savings_your_new_cost} {newCost}</div>}
                            </div>
                        </div>
                    )}
                    {showHeatPumpInfo && (
                        <div className='savings-element-wrapper text-center'>
                            <div className="savings-element">
                                <h2>{DataModel.lang.replace_heatpump_title}</h2>
                                <p className='large-text'>{DataModel.lang.replace_heatpump_text}</p>
                                {showCtaButtons(DataModel.lang.cta_buttons)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;
